@if (!(isPhonePortrait$ | async)) {
  <div class="computer">
    <div class="number">
      <h3 translate>clhtcbxtk000108k129d9ehto</h3>
    </div>
    <div class="bigBox">
      @if (photosList$ | async; as photoList) {
        <div class="box">
          <lib-virtual-scroll
            [barOverContent]="true"
            [gridItemSize]="gridItemSize"
            [isFull]="false"
            [itemTpl]="item"
            [photos]="photoList"
            [targetHeight]="gridItemSize"
            type="grid"
          >
          </lib-virtual-scroll>
          <ng-template #item let-index let-photo>
            <div
              (click)="checkPhoto(photo.photo.photoId)"
              class="photo {{ photo.photo.check }}SelectPhoto"
            >
              <lib-image-loader
                [isCover]="true"
                [url]="
                  photo.photo
                    | getImageUrl
                      : photo.photo.photoGroupId
                      : 'anyone'
                      : context
                      : '1'
                      : 600
                    | async
                "
              ></lib-image-loader>
              @if (!photo.photo.check) {
                <mat-icon class="ring"></mat-icon>
              }
              @if (photo.photo.check) {
                <mat-icon class="check">done</mat-icon>
              }
            </div>
          </ng-template>
        </div>
      }
    </div>
    <div class="buttons">
      <lib-button
        class="addToBasket"
        lg
        (click)="swapPhoto.emit(photoId)"
        forceContext="common"
        translate
      >
        clhtcat27000008k15xrqdtx7
      </lib-button>
    </div>
  </div>
}

@if (isPhonePortrait$ | async) {
  <div class="phone">
    <div [title]="gridItemSize" class="number" translate>
      clhtcbxtk000108k129d9ehto
    </div>
    <div class="bigBox">
      @if (photosList$ | async; as photoList) {
        <div class="box">
          <lib-virtual-scroll
            [barOverContent]="true"
            [gridItemSize]="gridItemSize"
            [isFull]="false"
            [itemTpl]="item"
            [photos]="photoList"
            [targetHeight]="gridItemSize"
            type="grid"
          >
          </lib-virtual-scroll>
          <ng-template #item let-index let-photo>
            <div
              (click)="checkPhoto(photo.photo.photoId)"
              class="photo {{ photo.photo.check }}SelectPhoto"
            >
              <lib-image-loader
                [isCover]="true"
                [url]="
                  photo.photo
                    | getImageUrl
                      : photo.photo.photoGroupId
                      : 'anyone'
                      : context
                      : '1'
                      : 600
                    | async
                "
              ></lib-image-loader>
              @if (!photo.photo.check) {
                <mat-icon class="ring"></mat-icon>
              }
              @if (photo.photo.check) {
                <mat-icon class="check">done</mat-icon>
              }
            </div>
          </ng-template>
        </div>
      }
    </div>
    <div class="buttons">
      <lib-button (click)="closeDialog.emit()" forceContext="common" translate
        >comeBack</lib-button
      >
      <lib-button
        (click)="swapPhoto.emit(photoId)"
        forceContext="common"
        translate
      >
        clhtcat27000008k15xrqdtx7
      </lib-button>
    </div>
  </div>
}
